/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ComponentDataTable } from '../../components';
import { debounceIndexCandidatesRequest } from '../../requests/candidates';
import columns from './Columns';

const CandidateDatatable = ({ customParams = {} }) => {
  const [onRequest, setOnRequest] = useState(true);
  const [candidates, setCandidates] = useState([]);
  const [amount, setAmount] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSuccessIndex = response => {
    const { data, metadata } = response.data;
    setAmount(metadata.amount);
    setCandidates(data);
  };

  const handleParams = params => {
    const defaultParams = {
      display_length: 15,
      display_start: 0,
      sort_column: 'created_at',
      sort_direction: 'desc'
    };
    return { ...defaultParams, ...customParams, ...params };
  };

  const handleRequest = params => {
    setOnRequest(true);
    debounceIndexCandidatesRequest({
      dispatch,
      params: handleParams(params),
      successCallback: handleSuccessIndex,
      callback: () => setOnRequest(false)
    });
  };

  const handleButtonClick = (item, action) => {
    switch (action) {
      case 'show': {
        const selectionProcessId = item.selection_processes?.[0]?.value;
        history.push(`/selection_processes/${selectionProcessId}/candidates/${item.id}`);
        break;
      }
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
        break;
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'careers':
        return { sort_careers: name };
      case 'selection_processes':
        return { sort_selection_processes: name };
      default:
        return { sort_column: name };
    }
  };

  useEffect(handleRequest, [customParams]);

  return (
    <ComponentDataTable
      onRequest={onRequest}
      columns={columns(handleButtonClick)}
      data={candidates}
      totalRows={amount}
      handleSortCase={sortColumnCase}
      resourceRequest={handleRequest}
      onRowClicked={item => handleButtonClick(item, 'show')}
      pointerOnHover
    />
  );
};

export default CandidateDatatable;
